import * as React from 'react';
import translate from '../../../../locale/translate';

import { CheckboxInput } from '../../common/Input';
import { NodeTagFilterEditor, NodeSystemFilterEditor } from '../../common/Editor';
import ISettings from './ISettings';
import { IInputChangeEventHandler } from '../../../../interfaces';
import { Tag } from '../../../../store/models';

import { getDisplayValue, formatDate } from '../../util/StringUtil';

interface IProps {
    data: { tags: Tag[] },
    settings: ISettings,
    handleChange: IInputChangeEventHandler,
}

export default class Editor extends React.Component<IProps, void> {
    handleChange(evt: React.ChangeEvent<HTMLInputElement>) {
        this.props.handleChange(evt.target.name, evt.target.checked);
    }

    render() {
        const { settings, handleChange } = this.props;
        const now = new Date();

        return (
            <div>
                <h3>{translate.gettext('Filter')}</h3>

                <NodeTagFilterEditor {...this.props} />

                <h3>{translate.gettext("Display")}</h3>
                <CheckboxInput
                    name="displaySystemsWithoutJobs"
                    label={translate.gettext("Systems without jobs")}
                    checked={settings.displaySystemsWithoutJobs}
                    onChange={this.handleChange.bind(this)}
                />

                <hr />
                <CheckboxInput
                    name="displaySuccessfulJobs"
                    label={translate.gettext("Successful")}
                    checked={settings.displaySuccessfulJobs}
                    onChange={this.handleChange.bind(this)}
                />
                <CheckboxInput
                    name="displayFailedJobs"
                    label={translate.gettext("Failed")}
                    checked={settings.displayFailedJobs}
                    onChange={this.handleChange.bind(this)}
                />
                <CheckboxInput
                    name="displayInProgressJobs"
                    label={translate.gettext("In progress")}
                    checked={settings.displayInProgressJobs}
                    onChange={this.handleChange.bind(this)}
                />
                <hr />
                <CheckboxInput
                    name="displayDownloadJobs"
                    label={translate.gettext("Downloads")}
                    checked={settings.displayDownloadJobs}
                    onChange={this.handleChange.bind(this)}
                />
                <CheckboxInput
                    name="displayInstallJobs"
                    label={translate.gettext("Install")}
                    checked={settings.displayInstallJobs}
                    onChange={this.handleChange.bind(this)}
                />
                <CheckboxInput
                    name="displayScanJobs"
                    label={translate.gettext("Scans")}
                    checked={settings.displayScanJobs}
                    onChange={this.handleChange.bind(this)}
                />

                <h3>{translate.gettext('Columns')}</h3>
                <CheckboxInput
                    label={translate.gettext("State")}
                    name="displayState"
                    checked={settings.displayState}
                    onChange={this.handleChange.bind(this)} />

                <CheckboxInput
                    label={translate.gettext("Message")}
                    name="displayMessage"
                    checked={settings.displayMessage}
                    onChange={this.handleChange.bind(this)} />

                <CheckboxInput
                    label={translate.gettext("Start time")}
                    name="displayStartTime"
                    checked={settings.displayStartTime}
                    onChange={this.handleChange.bind(this)} />

                <CheckboxInput
                    label={translate.gettext("End time")}
                    name="displayEndTime"
                    checked={settings.displayEndTime}
                    onChange={this.handleChange.bind(this)} />
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/widget/su/listJobs/Editor.tsx